/* AC Store v1 behaviour: reveals, header state, lock-on, product gallery + variant picker, sticky add-to-cart.
   No library. Every move can be interrupted; nothing waits on an animation. */
(function () {
  'use strict';
  var d = document, reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hover = matchMedia('(hover: hover)').matches;
  d.documentElement.classList.add('js');

  /* scroll reveal (a scan line draws each section in once) */
  var rv = d.querySelectorAll('.rv');
  if (reduce || !('IntersectionObserver' in window)) rv.forEach(function (e) { e.classList.remove('rv'); });
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    rv.forEach(function (e) { io.observe(e); });
  }

  /* header over the hero turns solid once you scroll */
  var top = d.querySelector('.top.over');
  if (top) addEventListener('scroll', function () { top.classList.toggle('scrolled', scrollY > 40); }, { passive: true });

  /* phone menu */
  var mb = d.querySelector('.menu-btn'), dr = d.getElementById('ac-drawer');
  if (mb && dr) mb.addEventListener('click', function () {
    var open = dr.hasAttribute('open');
    open ? dr.removeAttribute('open') : dr.setAttribute('open', '');
    mb.setAttribute('aria-expanded', String(!open));
  });

  /* background sweep pauses when the tab is hidden */
  d.addEventListener('visibilitychange', function () { d.body.classList.toggle('paused', d.hidden); });

  /* lock-on: sweep once on hover (mouse) or once when the case scrolls into view (touch) */
  function hot(l) { l.classList.remove('hot'); void l.offsetWidth; l.classList.add('hot'); }
  function pulse(l) { if (reduce) return; l.classList.remove('pulse'); void l.offsetWidth; l.classList.add('pulse'); }
  d.querySelectorAll('.lock[data-sweep]').forEach(function (l) {
    if (hover) l.addEventListener('mouseenter', function () { if (!reduce) hot(l); });
  });
  if (!hover && !reduce && 'IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { hot(e.target); so.unobserve(e.target); } });
    }, { threshold: .6 });
    d.querySelectorAll('.lock[data-sweep]').forEach(function (l) { so.observe(l); });
  }

  /* product: gallery slots */
  var pp = d.querySelector('[data-ac-product]');
  if (!pp) return;
  var main = pp.querySelector('[data-main] img'), mainLock = pp.querySelector('[data-main]');
  pp.querySelectorAll('[data-slot]').forEach(function (b) {
    b.addEventListener('click', function () {
      pp.querySelectorAll('[data-slot]').forEach(function (x) { x.closest('.lock').classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.closest('.lock').classList.add('on'); b.setAttribute('aria-pressed', 'true');
      main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || '';
      if (!reduce) hot(mainLock);
      pulse(b.closest('.lock'));
    });
  });

  /* product: options -> variant */
  var data = d.querySelector('[data-variants]'), variants = data ? JSON.parse(data.textContent) : [];
  var idInput = pp.querySelector('input[name="id"]'), atc = d.querySelectorAll('[data-atc]');
  var priceEl = pp.querySelector('[data-price]'), stickyLabel = d.querySelector('[data-sticky-label]');
  var status = pp.querySelector('[data-status]');
  function chosen() {
    var opts = [];
    pp.querySelectorAll('[data-option]').forEach(function (fs) {
      var c = fs.querySelector('input:checked'); opts[+fs.dataset.option] = c ? c.value : null;
    });
    return opts;
  }
  function update(e) {
    var opts = chosen();
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] == null || opts[i] === o; }); });
    if (e && e.target) {
      var fs = e.target.closest('[data-option]');
      fs.querySelectorAll('.lock').forEach(function (l) { l.classList.toggle('on', l.contains(e.target)); });
      pulse(e.target.closest('.lock'));
    }
    if (!v) { atc.forEach(function (b) { b.disabled = true; b.textContent = b.dataset.unavailable; }); return; }
    idInput.value = v.id;
    priceEl.textContent = v.price;
    picked = picked || !!e;
    atc.forEach(function (b) {
      b.disabled = !v.available;
      b.textContent = !v.available ? b.dataset.soldout : (b.dataset.choose && !picked ? b.dataset.choose : b.dataset.add);
    });
    if (stickyLabel) stickyLabel.textContent = v.label + ' · ' + v.price;
    if (status) status.textContent = '';
    var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
  }
  pp.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });
  /* sticky button: until a size is picked it scrolls to the sizes (print on demand: no returns for a wrong size) */
  var picked = /[?&]variant=/.test(location.search) || !pp.querySelector('[data-option]');
  var sb = d.querySelector('[data-sticky]');
  if (sb) {
    if (picked) { sb.textContent = sb.dataset.add; if (stickyLabel) update(); }
    sb.addEventListener('click', function () {
      if (!picked) {
        var fs = pp.querySelector('[data-option]');
        fs.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        fs.querySelectorAll('.lock').forEach(pulse);
        var first = fs.querySelector('input:checked') || fs.querySelector('input'); if (first) first.focus({ preventScroll: true });
        return;
      }
      var f = d.getElementById('ac-pf'); f.requestSubmit ? f.requestSubmit() : f.submit();
    });
  }

  /* sticky add-to-cart on phones: shows whenever the main button is off screen */
  var sticky = d.querySelector('.sticky-atc'), mainBtn = pp.querySelector('.details [data-atc]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { sticky.classList.toggle('show', !es[0].isIntersecting); })
      .observe(mainBtn);
  }
})();
